<div class="flex flex-col p-base">
  <!-- Header -->
  <div class="flex items-center justify-between mb-base">
    <div class="text-base leading-base font-semibold">Select Month</div>
    <lla-button
      variant="ghost"
      size="medium-shrink"
      icon="close"
      (click)="dialogRef.close()"
    ></lla-button>
  </div>

  <lla-month-selector
    [selectedMonth]="selectedMonth"
    [includeFuture]="includeFuture"
    (monthSelected)="onMonthSelected($event)"
  ></lla-month-selector>
</div>
